import { Headline } from 'forly-kit';
import { colors } from 'forly-kit/dist/colors';
import { Logo } from 'forly-kit/dist/icons';
import { t } from 'i18next';
import React from 'react';
import { LanguageSwitcher } from '../LanguageSwitcher/LanguageSwitcher';
import styles from './pasportLayout.module.scss';
import { IPasportLayout } from './pasportLayout.types';

const LayoutComponent: React.FC<IPasportLayout> = ({children}) => {
	return <div className={styles.wrapper}>
		<div className={styles.leftSide}>
			<Logo />
			<div className={styles.header}>
				<Headline type="h0" color={colors.white}>
					{t('investing')}
				</Headline>
				<Headline type="h3" color={colors.primary200}>
                — {t('investingSubtitle')}
				</Headline>
			</div>
		</div>
		<div className={styles.rightSide}>
			<LanguageSwitcher className={styles.languageSwitcher} />
			<div className={styles.contentBlock}>
				{children}
			</div>
		</div>
	</div>;
};

export const PasportLayout = React.memo(LayoutComponent);